import { render, staticRenderFns } from "./batchSorting.vue?vue&type=template&id=0a8d5662&scoped=true&"
import script from "./batchSorting.vue?vue&type=script&lang=js&"
export * from "./batchSorting.vue?vue&type=script&lang=js&"
import style0 from "./batchSorting.vue?vue&type=style&index=0&id=0a8d5662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d5662",
  null
  
)

export default component.exports